module.exports = __webpack_public_path__ + "static/media/petUser-final.5b42f312.svg";